const Builder = require('../BuilderBase');

module.exports = class ToAsciiFromHex extends Builder {
    constructor(properties) {
        super('transform_ToAsciiFromHex', '', properties);
    }
};
